import { render, staticRenderFns } from "./kdContainer.vue?vue&type=template&id=c553d84e&scoped=true"
import script from "./kdContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./kdContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c553d84e",
  null
  
)

export default component.exports